<app-content-loading [isLoading]="isLoading">
    <app-tab-list>
        <app-tab
            [tabTitle]="'translate_result_analysis' | translate"
            [tabCount]="resultAnalysisHistory.length"
        >
            <app-period-field-history-table
                type="result-analysis"
                [items]="resultAnalysisHistory"
            ></app-period-field-history-table>
        </app-tab>

        <app-tab
            [tabTitle]="'translate_improvement_procedures' | translate"
            [tabCount]="improvementProcedureHistory.length"
        >
            <app-period-field-history-table
                type="improvement-procedure"
                [items]="improvementProcedureHistory"
            ></app-period-field-history-table>
        </app-tab>
    </app-tab-list>
</app-content-loading>
